module.exports = __webpack_public_path__ + "b6e00f708c6e60714f2596919dde8a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/signup/layouts/Footer/wechat-qr.png
// module id = 1167
// module chunks = 0